import { IAuthSMSRequest, IAuthSMSVerifyRequest } from '../../interfaces/auth';
import { ProxyClient } from '../client/ProxyClient';

export const signInUser = async (requestData: IAuthSMSRequest) => {
  const { data } = await ProxyClient.post('/user/signin', requestData);

  if (data?.error) {
    throw new Error(data.error);
  }

  return data;
};

export const verifyUser = async (requestData: IAuthSMSVerifyRequest) => {
  const { data } = await ProxyClient.post('/user/verify', requestData);

  if (data?.error) {
    throw new Error(data.error.message);
  }

  return data;
};
